module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent menu-edit-wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Manage terms order in vocabulary " + _vm._s(_vm.source.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Builder")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VocabularyEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Edit vocabulary\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.orderChanged) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                Items order changed. Don't forget to save it!\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-builder"
  }, [_c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToTop
    }
  }, [_vm._v("Add item")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder-inner"
  }, [(_vm.faqTree.length) ? _c('ul', _vm._m(0), 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToBottom
    }
  }, [_vm._v("\n                    Add item\n                  ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success save-menu",
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Data saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.faqTree), function(item) {
    return _c('term-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a30f6f0c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/taxonomy/vocabulary/TermsOrder.vue
// module id = 971
// module chunks = 0